import React from "react";
import { CDBTable, CDBTableBody, CDBTableHeader, CDBIcon } from "cdbreact";
import moment from "moment";
import mastercardLogo from "../../../img/mastercard-logo.png";
import visaLogo from "../../../img/visa-logo.png";
import americanlogo from "../../../img/americanexpress-logo.png";
import edenredlogo from "../../../img/ednred-logo.png";
import sivalelogo from "../../../img/sivale-logo.png";
import nobrandLogo from "../../../img/nobrand-logo.png";
import sodexologo from "../../../img/sodexo-logo.png";

/**
 * Retorna la imagen correspondiente a la marca de la tarjeta.
 * @param {string} brand - Nombre de la marca de la tarjeta.
 * @returns {string} Ruta de la imagen importada.
 */
const getCardImage = (brand) => {
  if (!brand) return nobrandLogo;
  switch (brand.toLowerCase()) {
    case "mastercard": 
    case "master card": 
      return mastercardLogo;
    case "visa": 
      return visaLogo;
    case "american express": 
    case "amex": 
      return americanlogo;
    case "sodexo": 
      return sodexologo;
    case "sivale": 
      return sivalelogo;
    case "edenred": 
      return edenredlogo;
    default: 
      return nobrandLogo;
  }
};

/**
 * Renderiza una etiqueta visual (badge) dependiendo del estado de la transacción.
 * @param {string} status - Estado de la transacción proveniente del backend.
 * @returns {JSX.Element|null} Componente visual con el estado.
 */
const renderEstado = (status) => {
  if (!status) return null;
  const normalizedStatus = status.toLowerCase();
  const isApproved = ["approved", "approvedtransaction", "aprobada"].includes(normalizedStatus);
  const iconClass = isApproved ? "fa-check-circle" : "fa-times-circle";
  const backgroundColor = isApproved ? "#0E9600" : "#FF4444";
  const text = isApproved ? "Aprobada" : "Rechazada";
  
  return (
    <span
      style={{
        display: "inline-block", padding: "5px 10px", color: "white",
        backgroundColor, borderRadius: "8px", fontSize: "12px",
        fontWeight: "bold", textAlign: "center",
      }}
    >
      <i className={`fa ${iconClass}`} style={{ marginRight: "5px" }}></i>
      {text}
    </span>
  );
};

export const TransactionsTable = ({ items, selectedColumns, allColumns }) => {
  return (
    <CDBTable hover responsive maxHeight="70vh" scrollY className="responsive-table" style={{ fontSize: '15px', fontFamily: 'Montserrat, sans-serif', overflowX: 'auto', whiteSpace: 'nowrap' }}>
      <CDBTableHeader>
        <tr style={{ textAlign: "center", backgroundColor: "#3E4144", color: "white" }}>
          {allColumns.map(column => (column.alwaysShow || selectedColumns.includes(column.key)) && (
              <th key={column.key} style={{ borderTop: '1px solid #DCDCDC', borderBottom: '1px solid #DCDCDC', backgroundColor: '#DCDCDC', color: '#3E4144' }}>
                {column.label}
              </th>
            )
          )}
        </tr>
      </CDBTableHeader>
      <br />
      <CDBTableBody>
        {items.map((row, idx) => (
          <tr key={`${row.id}-${idx}`} style={{textAlign: "center"}}>
            {allColumns.map(column => {
              if (column.alwaysShow || selectedColumns.includes(column.key)) {
                
                // Extracción por defecto para propiedades en la raíz del objeto
                let content = row[column.property] || 'N/A';
                
                // Procesamiento especial según el 'key' de la columna
                switch (column.key) {
                  case "Fecha":
                    content = row.launch_time
                    ? moment(row.launch_time).format("YYYY/MM/DD hh:mm")
                    : "Fecha no disponible";
                    break;
                    
                  case "No.Tarjeta":
                    const imageSrc = getCardImage(row.payment_brand);
                    content = (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start"}}>
                        {imageSrc && <img src={imageSrc} alt={row.payment_brand} style={{ width: "40px", height: "20px", marginRight: "5px", objectFit: "contain"}} />}
                        <span>{`**** ${row.last_four_digits || '0000'}`}</span>
                      </div>
                    );
                    break;
                    
                  case "Estado":
                    content = renderEstado(row.status);
                    break;
                  
                  case "Total":
                  case "SubtotalIVA":
                  case "IvaFixedAmountValue":
                  case "ProviderFixedAmount":
                  case "Comision":
                  case "Subtotal":
                    const numericValue = Number(row[column.property]) || 0;
                    content = numericValue.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
                    break;


                  case "Nombre":
                    content = row.customer_name || 'N/A';
                    break;
                  case "Email":
                    content = row.email || 'N/A';
                    break;
                  case "Direccion":
                    content = row.address || 'N/A';
                    break;
                  case "Telefono":
                    content = row.phone || 'N/A';
                    break;
                }
                
                return <td key={column.key} data-label={column.label}>{content}</td>;
              }
              return null;
            })}
          </tr>
        ))}
      </CDBTableBody>
    </CDBTable>
  );
};